// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3Zekm","head":"ProcedureTableInfo_head__388_-"};